import {
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { GeoCodingService } from 'src/app/services/geo-coding.service';
import { GeolocationService } from 'src/app/services/geolocation.service';
import { UsersService } from 'src/app/services/users.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';
import { MapsAPILoader } from '@agm/core';
import { ChangeDetectorRef } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { CartStorage } from 'src/app/storage/cart';
import { ResumeStorage } from 'src/app/storage/resume';
import { DialogAddressComponent } from './dialog-address/dialog-address.component';
import { DialogNewAddressComponent } from './dialog-new-address/dialog-new-address.component';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
})
export class BaseComponent implements OnInit {
  itemsCart: number = 0;
  textoBusqueda: string = '';

  tokenNina: boolean = false;
  tokenSSGuest: boolean = false;
  tokenSSLoged: boolean = false;
  tokenSS: boolean = false;
  private initializingTokens = false;
  private tokenInitializationFinished = false;
  private ninaTokenAttempts = 0;
  private ssGuestTokenAttempts = 0;
  private couponsCheckedThisSession = 'nina_coupons_checked';

  dialogRefProdDeta: any = null;

  lines: any[] = [];
  sucursales: any[] = [];

  branchSelectorOpen: boolean = false;

  selectedBranchName: string = 'Selecciona tu sucursal';
  selectedBranch: any = null;

  cookieBranch: any = null;

  get navbarLines(): any[] {
    const result: any[] = [];

    for (const linea of this.lines) {
      result.push({
        ...linea,
        lineas: [linea],
      });
    }
    return result;
  }

  constructor(
    private loaderService: LoaderService,
    private coreService: CoreService,
    public dialog: MatDialog,
    public cookies: CookieService,
    public apiServices: ApiService,
    public router: Router,
    private _snackBar: MatSnackBar,
    public apiUsersServices: UsersService,
  ) {
    this.tokenNina = cookies.check('Token');
    this.tokenSSGuest = cookies.check('TokenU');
    this.tokenSSLoged = cookies.check('UL');
    this.tokenSS = cookies.check('ss');
  }

  ngOnInit(): void {
    this.tokenNina = this.cookies.check('Token');
    this.tokenSSGuest = this.cookies.check('TokenU');

    this.initializeSession();

    // if (CartStorage.exists()) {
    this.updateCart();
    // }

    this.coreService.emitSubjet.subscribe((response) => {
      if (response.type === 'Cart') {
        this.updateCart();
        this.getLineas();
        this.loadSelectedBranch();
      } else if (response.type === 'Snackbar') {
        this.snackBarSummon(response.payload.text);
      } else if (response.type === 'ShippingType') {
        if (response.payload.promotion != null) {
          // console.log("Data in Shippingtyoe", response)
          this.openShippingTypeDialog(
            null,
            0,
            0,
            response.payload.promotion,
            response.payload.user,
          );
        } else {
          this.openShippingTypeDialog(
            response.payload.product,
            response.payload.idProductoAgrupador,
            response.payload.qty,
            null,
            null,
          );
        }
      } else if (response.type === 'LoginExternal') {
        this.openDialogLogin();
      } else if (response.type === 'SaleResume') {
        this.openDialogSaleResume();
      } else if (response.type === 'Login') {
        this.openDialogLogin();
      } else if (response.type === 'ClearProductSearch') {
        this.textoBusqueda = '';
      } else if (response.type === 'RefreshLoged') {
        this.tokenNina = this.cookies.check('Token');
        this.tokenSSGuest = this.cookies.check('TokenU');
        this.tokenSSLoged = this.cookies.check('UL');
      }
    });
  }

  private initializeSession(): void {
    if (this.initializingTokens || this.tokenInitializationFinished) {
      return;
    }
    this.initializingTokens = true;
    this.loaderService.show();
    this.ensureNinaToken(() => {
      this.ensureSSGuestToken(() => {
        this.tokenNina = this.cookies.check('Token');
        this.tokenSSGuest = this.cookies.check('TokenU');
        this.initializingTokens = false;
        this.tokenInitializationFinished = true;
        this.loaderService.hide();
        this.finishInitialization();
      });
    });
  }

  toTitleCase(value: string): string {
    return value
      .toLocaleLowerCase('es-MX')
      .replace(/\b\w/g, (char) => char.toLocaleUpperCase('es-MX'));
  }

  goToLinea(linea: any): void {
    this.textoBusqueda = '';
    this.coreService.emitSubjet.next({
      type: 'ClearProductSearch',
      payload: null,
    });

    const ids = linea.lineas
      .map((item: any) => item?.idLineaApp)
      .filter((id: any) => id != null);

    this.router.navigate(['/store'], {
      queryParams: {
        line: ids.join(','),
      },
    });
  }

  private ensureNinaToken(onComplete: () => void): void {
    if (this.cookies.check('Token')) {
      this.tokenNina = true;
      this.ninaTokenAttempts = 0;

      onComplete();
      return;
    }

    this.apiServices.getToken().subscribe({
      next: (value) => {
        if (value?.[0]?.token) {
          const tomorrow = new Date();

          tomorrow.setHours(0, 0, 0, 0);
          tomorrow.setDate(tomorrow.getDate() + 1);

          this.cookies.set('Token', value[0].token, {
            expires: tomorrow,
            sameSite: 'Strict',
          });

          this.tokenNina = true;
          this.ninaTokenAttempts = 0;

          onComplete();
        } else {
          this.retryNinaToken(onComplete);
        }
      },

      error: (err) => {
        console.error('Token Nina', err);

        this.retryNinaToken(onComplete);
      },
    });
  }

  private retryNinaToken(onComplete: () => void): void {
    if (this.ninaTokenAttempts < 5) {
      this.ninaTokenAttempts++;

      setTimeout(() => {
        this.ensureNinaToken(onComplete);
      }, 1500);

      return;
    }

    this.initializingTokens = false;
    this.loaderService.hide();

    this.coreService.emitSubjet.next({
      type: 'Snackbar',
      payload: {
        text: 'No fue posible conectar con el servidor',
      },
    });
  }

  private ensureSSGuestToken(onComplete: () => void): void {
    if (this.cookies.check('TokenU')) {
      this.tokenSSGuest = true;
      this.ssGuestTokenAttempts = 0;

      onComplete();
      return;
    }

    const data = {
      email: environment.guestEmail,
      password: environment.guestPassword,
    };

    this.apiUsersServices.loginGuest(data).subscribe({
      next: (value) => {
        if (value?.status && value.data?.token) {
          const twentyDays = new Date();

          twentyDays.setHours(0, 0, 0, 0);
          twentyDays.setDate(twentyDays.getDate() + 20);

          this.cookies.set('TokenU', value.data.token, {
            expires: twentyDays,
            sameSite: 'Strict',
          });

          this.tokenSSGuest = true;
          this.ssGuestTokenAttempts = 0;

          onComplete();
        } else {
          this.retrySSGuestToken(onComplete);
        }
      },

      error: (err) => {
        console.error('Token SS Guest', err);

        this.retrySSGuestToken(onComplete);
      },
    });
  }

  private retrySSGuestToken(onComplete: () => void): void {
    if (this.ssGuestTokenAttempts < 5) {
      this.ssGuestTokenAttempts++;

      setTimeout(() => {
        this.ensureSSGuestToken(onComplete);
      }, 1500);

      return;
    }

    this.initializingTokens = false;
    this.loaderService.hide();

    this.coreService.emitSubjet.next({
      type: 'Snackbar',
      payload: {
        text: 'No fue posible iniciar sesión como invitado',
      },
    });
  }

  private finishInitialization(): void {
    this.tokenNina = this.cookies.check('Token');
    this.tokenSSGuest = this.cookies.check('TokenU');

    if (!this.tokenNina) {
      return;
    }

    this.getBranches();
    this.getLineas();

    if (this.tokenNina && this.tokenSSGuest) {
      this.router.navigate(['/home']);
    }

    this.tokenSS = this.cookies.check('ss');
    this.tokenSSLoged = this.cookies.check('UL');

    if (this.tokenSS && this.tokenSSLoged) {
      this.checkCoupons();
    }
  }

  getBranches(): void {
    const data = {
      token: this.cookies.get('Token'),
    };

    this.apiServices.getSucursales(data).subscribe({
      next: (value) => {
        this.sucursales = value ?? [];
        this.loadSelectedBranch();
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  checkCoupons(): void {
    if (sessionStorage.getItem(this.couponsCheckedThisSession) === 'true') {
      return;
    }
    if (!this.cookies.check('ss') || !this.cookies.check('UL')) {
      return;
    }
    sessionStorage.setItem(this.couponsCheckedThisSession, 'true');

    this.getCoupons(false);
  }

  getCoupons(retryAfterTokenRefresh: boolean = false): void {
    let phone = localStorage.getItem('userPhone') ?? '';
    phone = phone.replace(/^\+?52/, '');

    const data = {
      pIdCliente: Number(this.cookies.get('uid')) ?? '',
      pTelefono: phone,
      pSSToken: this.cookies.get('ss') ?? '',
      pNinaToken: this.cookies.get('Token') ?? '',
    };

    // console.log('Checking coupons with data:', data);
    this.apiServices.getBoletos(data).subscribe({
      next: (value) => {
        const result = value?.[0];
        if (!result) {
          return;
        }
        if (Number(result.error) === 0) {
          if (result.desplegar === true) {
            this.openDialogShowCoupons({
              boletos: result.boletos ?? 0,
              titulo: result.titulo ?? '',
            });
          }
          return;
        }

        if (Number(result.error) === 77 && !retryAfterTokenRefresh) {
          this.refreshSSAndRetryCoupons();
          return;
        }

        if (result.mensaje) {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text: result.mensaje,
            },
          });
        }
      },
      error: (err) => {
        console.error('Boletos', err);
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: 'Hubo un error al consultar tus boletos',
          },
        });
      },
    });
  }

  refreshSSAndRetryCoupons(): void {
    this.loaderService.show();
    this.apiUsersServices.me().subscribe({
      next: (value) => {
        if (value.status && value.data?.ssToken) {
          this.cookies.set('ss', value.data.ssToken, {
            expires: 1,
            sameSite: 'Strict',
          });
          this.getCoupons(true);
        } else {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text: value.message || 'No fue posible actualizar la sesión',
            },
          });
        }
        this.loaderService.hide();
      },
      error: (err) => {
        console.error('Actualizar SS', err);
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: 'No fue posible actualizar la sesión' },
        });
        this.loaderService.hide();
      },
    });
  }

  openDialogShowCoupons(data: any): void {
    const isMobile = window.innerWidth <= 768;
    this.dialog.open(DialogShowCoupons, {
      width: isMobile ? '92vw' : '460px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: '90vh',
      backdropClass: 'nina-dialog-backdrop',
      autoFocus: false,
      data: data,
    });
  }

  private lineasRequestId = 0;

  getLineas(): void {
    const requestId = ++this.lineasRequestId;
    const token = this.cookies.get('Token');
    const branchCookie = this.cookies.get('Branch');

    if (branchCookie) {
      try {
        this.cookieBranch = JSON.parse(branchCookie);
      } catch (error) {
        console.error('Error leyendo la cookie Branch:', error);
        this.cookies.delete('Branch');
        this.cookieBranch = null;
      }
    } else {
      this.cookieBranch = null;
    }

    // Sin sucursal seleccionada, consultar todas las líneas.
    if (!this.cookieBranch?.idSucursal) {
      this.lines = [];

      this.apiServices.getLineas({ token }).subscribe({
        next: (value) => {
          if (requestId !== this.lineasRequestId) {
            return;
          }

          // Evita aplicar una respuesta correspondiente a un estado anterior.
          if (this.cookies.get('Branch')) {
            this.getLineas();
            return;
          }

          this.lines = value ?? [];
        },
        error: (err) => {
          if (requestId === this.lineasRequestId) {
            console.error('Error al consultar todas las líneas:', err);
          }
        },
      });

      return;
    }

    // Con sucursal seleccionada, consultar solo sus líneas.
    const data = {
      token,
      idSucursal: this.cookieBranch.idSucursal,
    };

    this.apiServices.getLineasSucursal(data).subscribe({
      next: (value) => {
        if (requestId !== this.lineasRequestId) {
          return;
        }

        const currentBranchCookie = this.cookies.get('Branch');

        if (!currentBranchCookie) {
          this.getLineas();
          return;
        }

        try {
          const currentBranch = JSON.parse(currentBranchCookie);

          if (
            Number(currentBranch.idSucursal) !==
            Number(data.idSucursal)
          ) {
            this.getLineas();
            return;
          }
        } catch (error) {
          this.getLineas();
          return;
        }

        this.lines = value ?? [];
      },
      error: (err) => {
        if (requestId === this.lineasRequestId) {
          console.error('Error al consultar las líneas de la sucursal:', err);
        }
      },
    });
  }

  goToAccount(): void {
    this.tokenSSLoged = this.cookies.check('UL');
    if (this.tokenSSLoged) {
      this.router.navigate(['/profile']);
    } else {
      this.openDialogLogin();
    }
  }

  loadSelectedBranch(): void {
    const branchCookie = this.cookies.get('Branch');

    if (!branchCookie) {
      this.selectedBranch = null;
      this.selectedBranchName = 'Selecciona tu sucursal';
      return;
    }

    try {
      const branch = JSON.parse(branchCookie);
      this.selectedBranch = branch;
      this.selectedBranchName = this.formatBranchName(branch.nombre);
    } catch (error) {
      console.error('Error leyendo Branch:', error);
      this.selectedBranch = null;
      this.selectedBranchName = 'Selecciona tu sucursal';
    }
  }

  toggleBranchSelector(): void {
    this.branchSelectorOpen = !this.branchSelectorOpen;
  }
  isSelectedBranch(branch: any): boolean {
    return (
      Number(branch.idSucursal) === Number(this.selectedBranch?.idSucursal)
    );
  }

  formatBranchName(nombre: string): string {
    const names: Record<string, string> = {
      'JUAREZ (NVO TORREON)': 'Sucursal Centro • Matriz',

      SENDEROS: 'Sucursal Senderos',

      'SAN ISIDRO': 'Sucursal Galerías',

      'MIGUEL ALEMAN (GP)': 'Gómez Palacio',

      LERDO: 'Lerdo',
    };

    return names[nombre] ?? nombre;
  }

  selectBranch(branch: any): void {
    this.selectedBranch = branch;
    this.selectedBranchName = this.formatBranchName(branch.nombre);
    this.cookies.set('Branch', JSON.stringify(branch), {
      expires: 7,
      sameSite: 'Strict',
    });
    this.branchSelectorOpen = false;
    this.getLineas();
  }

  updateCart() {
    this.itemsCart = 0;
    if (!this.cookies.check('Branch')) {
      CartStorage.clear();
    }
    else {
      if (CartStorage.exists()) {
        let theItemsInCart = CartStorage.getCart();
        if (theItemsInCart.length > 0) {
          theItemsInCart.forEach((element: any) => {
            this.itemsCart = this.itemsCart + element.qty;
          });
        } else {
          this.itemsCart = 0;
        }
        if (this.itemsCart === 0) {
          this.cookies.delete('Branch');
        }
      } else {
        this.itemsCart = 0;
        this.cookies.delete('Branch');
      }
    }
  }

  busqueda(event: any) {
    const currentUrl = this.router.url.split('?')[0];

    if (this.textoBusqueda.length > 0) {
      if (currentUrl === '/store') {
        const sendText = this.textoBusqueda;
        this.coreService.emitSubjet.next({
          type: 'ProductSearch',
          payload: {
            text: sendText,
          },
        });
      } else {
        this.router.navigate(['/store'], {
          queryParams: {
            filter: this.textoBusqueda,
          },
        });
      }
    }
  }

  onKeyUp(event: KeyboardEvent) {
    let currentUrl = this.router.url;
    currentUrl =
      currentUrl[0] +
      currentUrl[1] +
      currentUrl[2] +
      currentUrl[3] +
      currentUrl[4] +
      currentUrl[5];
    const keysToCheck = ['Backspace', 'Delete'];

    if (keysToCheck.includes(event.key) && this.textoBusqueda === '') {
      if (currentUrl === '/store') {
        let sendText = this.textoBusqueda;
        this.textoBusqueda = '';
        this.coreService.emitSubjet.next({
          type: 'ProductSearch',
          payload: { text: sendText },
        });
      }
    }
  }

  logout() {
    this.loaderService.show();
    this.apiUsersServices.logout().subscribe({
      next: (value) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: value.message },
        });
        if (value.status) {
          try {
            this.cookies.delete('UL');
            this.cookies.delete('ss');
            this.coreService.emitSubjet.next({
              type: 'Snackbar',
              payload: { text: 'Session Cerrada' },
            });
            localStorage.removeItem('userPhone');
            this.tokenSSLoged = this.cookies.check('UL');
            sessionStorage.removeItem('nina_coupons_checked');
            this.router.navigate(['/home']);
          } catch (err) {
            this.coreService.emitSubjet.next({
              type: 'Snackbar',
              payload: { text: 'Error' },
            });
            this.cookies.delete('UL');
            this.cookies.delete('ss');
            this.tokenSSLoged = this.cookies.check('UL');
            sessionStorage.removeItem('nina_coupons_checked');
          }
        }
        this.loaderService.hide();
      },
      error: (err) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: 'Hubo un error al procesar tu solicitud' },
        });
        console.error(err);
        this.cookies.delete('UL');
        this.tokenSSLoged = this.cookies.check('UL');
        this.loaderService.hide();
      },
    });
  }

  openDialogLogin() {
    const isMobile = window.innerWidth <= 768;

    const dialogRef = this.dialog.open(DialogLogin, {
      width: isMobile ? '92vw' : '350px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: 'calc(100vh - 30px)',
      backdropClass: 'nina-dialog-backdrop',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.tokenNina = this.cookies.check('Token');
      this.tokenSSGuest = this.cookies.check('TokenU');
      this.tokenSSLoged = this.cookies.check('UL');

      this.coreService.emitSubjet.next({
        type: 'RefreshLoged',
        payload: null,
      });

      if (this.tokenSS && this.tokenSSLoged) {
        this.checkCoupons();
      }

      document.body.classList.remove('mat-mdc-dialog-surface');
    });
  }

  openDialogSaleResume() {
    const isMobile = window.innerWidth <= 768;

    const dialogRef = this.dialog.open(DialogSaleResume, {
      width: isMobile ? '92vw' : '920px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: '90vh',
      backdropClass: 'nina-dialog-backdrop',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (ResumeStorage.exists()) {
        ResumeStorage.clear();
        this.cookies.delete('Branch');
        this.cookies.delete('BranchTemp');
      }
    });
  }

  openShippingTypeDialog(
    product: any,
    idProductoAgrupador: number,
    qty: number,
    promotion: any,
    user: any,
  ) {
    const isMobile = window.innerWidth <= 768;

    const dialogRef = this.dialog.open(DialogShippingType, {
      width: isMobile ? '94vw' : '95vw',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: 'calc(100vh - 30px)',
      backdropClass: 'nina-dialog-backdrop',
      autoFocus: false,
      data: {
        product: product,
        idProductoAgrupador: idProductoAgrupador,
        qty: qty,
        promotion: promotion,
        user: user,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.coreService.emitSubjet.next({ type: 'Cart', payload: null });
      this.coreService.emitSubjet.next({
        type: 'RefreshDetail',
        payload: null,
      });
      this.coreService.emitSubjet.next({ type: 'CloseDetail', payload: null });
    });
  }

  snackBarSummon(message: string) {
    this._snackBar.open(message, 'Cerrar', {
      duration: 5500,
    });
  }
}

@Component({
  selector: 'dialog-login',
  templateUrl: 'dialog-login.html',
  styleUrls: ['dialog-login.scss'],
})
export class DialogLogin {
  loginForm: any;
  registerForm: any;
  registerMode: boolean = false;
  minDate?: Date;
  maxDate?: Date;
  dataLocalities: Observable<any[]> = of([]);
  dataMunicipality: any;
  dataState: any;
  attempts = 0;

  constructor(
    private loaderService: LoaderService,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<DialogLogin>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public apiServices: ApiService,
    public formBuilder: FormBuilder,
    public router: Router,
    public cookieService: CookieService,
    public apiUsersServices: UsersService,
    private gtm: GoogleTagManagerService,
  ) {
    this.createForms();
  }

  ngOnInit(): void { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  createForms() {
    this.loginForm = this.formBuilder.group({
      phone: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/^\d+$/),
        ],
      ],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(64),
        ],
      ],
    });

    this.registerForm = this.formBuilder.group({
      names: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(64),
        ],
      ],
      last_name: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(64),
        ],
      ],
      last_name2: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(64),
        ],
      ],
      email: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(64)],
      ],
      phone: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/^\d+$/),
        ],
      ],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(64),
        ],
      ],
      birthdate: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      gender_value: [''],
      main_zip_code: [
        '',
        [Validators.required, Validators.minLength(5), Validators.maxLength(5)],
      ],
      state_id: ['', [Validators.required]],
      municipality_id: ['', [Validators.required]],
      locality_id: ['', [Validators.required]],
      state: ['', []],
      municipality: ['', []],

      terms_conditions: [false],
      privacy_notice: [false],
    });

    //this.minDate = moment().subtract(18, 'years').toDate();
    this.maxDate = moment().subtract(18, 'years').toDate();
  }

  onGenderChange(): void {
    this.registerForm.get('gender').valueChanges.subscribe((value: string) => {
      const genderValueControl = this.registerForm.get('gender_value');
      if (value === 'O') {
        genderValueControl.setValidators([Validators.required]);
      } else {
        genderValueControl.setValidators(null);
        genderValueControl.setValue('');
      }
      genderValueControl.updateValueAndValidity();
    });
  }

  login() {
    this.attempts++;
    this.loaderService.show();
    let dataForm = { ...this.loginForm.value };
    dataForm.device_id = 'device_web';
    dataForm.phone = '52' + dataForm.phone;
    dataForm.attempts = this.attempts;

    this.apiUsersServices.loginMobile(dataForm).subscribe({
      next: (value) => {
        // console.log("Login response:", value);
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: value.message },
        });
        const isActive = value.data?.user?.active === true;
        const hasCode = !!value.data?.code;

        if (
          value.status === true ||
          (environment.development &&
            value.status === false &&
            value.message === 'Mensaje de confirmación falló el envío.')
        ) {
          localStorage.setItem('userPhone', dataForm.phone);
          if (isActive === true || hasCode) {
            const isMobile = window.innerWidth <= 768;
            this.loaderService.hide();

            const dialogRef = this.dialog.open(DialogConfirmCode, {
              width: isMobile ? '90vw' : '350px',
              maxWidth: '95vw',
              height: 'auto',
              maxHeight: 'calc(100vh - 30px)',
              backdropClass: 'nina-dialog-backdrop',
              data: {
                phone: dataForm.phone,
                userData: value.data.user,
                userDataResponse: value.data.user,
                code: value.data.code ?? null,
                isFirstTime: false,
                attempts: this.attempts,
              },
            });

            dialogRef.afterClosed().subscribe((result) => {
              this.attempts = Number(localStorage.getItem('attempts'));
              this.dialogRef.close();
            });
          } else {
            this.cookieService.set('uid', value.data.user.id, {
              expires: 1,
              sameSite: 'Strict',
            });
            this.cookieService.set('ss', value.data.ssToken, {
              expires: 1,
              sameSite: 'Strict',
            });
            this.cookieService.set('UL', value.data.token, {
              expires: 1,
              sameSite: 'Strict',
            });
            this.registerMode = false;
            this.dialogRef.close();
          }
        }
        this.loaderService.hide();
      },
      error: (err) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: 'Hubo un error al procesar tu solicitud' },
        });
        console.error(err);
        this.loaderService.hide();
      },
    });
  }

  sendTemporalPassword() {
    this.loaderService.show();
    let dataForm: any = {};
    dataForm.phone = '52' + this.loginForm.value.phone;

    this.apiUsersServices.sendTemporalPassword(dataForm).subscribe({
      next: (value) => {
        // console.log(value);
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: value.message },
        });
        let development = environment.development;
        if (development) {
          if (value.status) {
            this.loginForm.get('password').setValue(value.data);
          }
        }
        this.loaderService.hide();
      },
      error: (err) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: 'Hubo un error al procesar tu solicitud' },
        });
        console.error(err);
        this.loaderService.hide();
      },
    });
  }

  changeRegister() {
    this.gtm.pushTag({ event: 'signup_start' });
    this.registerMode = true;
  }

  get names() {
    return this.registerForm.get('names');
  }
  get last_name() {
    return this.registerForm.get('last_name');
  }
  get last_name2() {
    return this.registerForm.get('last_name2');
  }
  get email() {
    return this.registerForm.get('email');
  }
  get phone() {
    return this.registerForm.get('phone');
  }
  get password() {
    return this.registerForm.get('password');
  }
  get birthdate() {
    return this.registerForm.get('birthdate');
  }
  get gender() {
    return this.registerForm.get('gender');
  }
  get gender_value() {
    return this.registerForm.get('gender_value');
  }
  get main_zip_code() {
    return this.registerForm.get('main_zip_code');
  }
  get state_id() {
    return this.registerForm.get('state_id');
  }
  get municipality_id() {
    return this.registerForm.get('municipality_id');
  }
  get locality_id() {
    return this.registerForm.get('locality_id');
  }
  get state() {
    return this.registerForm.get('state');
  }
  get municipality() {
    return this.registerForm.get('municipality');
  }

  getErrorMessage(control: string): string {
    const controlErrors = this.registerForm.get(control)?.errors;
    if (controlErrors) {
      if (controlErrors.required) {
        return 'Este campo es requerido';
      } else if (controlErrors.minlength) {
        return `La longitud minima es: ${controlErrors.minlength.requiredLength}`;
      } else if (controlErrors.maxlength) {
        return `La longitud maxima es: ${controlErrors.maxlength.requiredLength}`;
      } else if (controlErrors.pattern) {
        return 'Formato invalido';
      }
    }
    return '';
  }

  searchDataZipCode() {
    let theZipCode = this.registerForm.value['main_zip_code'];
    if (theZipCode.length == 5) {
      this.apiUsersServices.getLocalitiesByZipCode(theZipCode).subscribe({
        next: (value) => {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: value.message },
          });
          if (value.status) {
            this.dataLocalities = of(value.data);
          }
        },
        error: (err) => {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: 'Hubo un error al procesar tu solicitud' },
          });
        },
      });
    }
  }

  onSelectionLocality(event: any) {
    let theLocality: any;
    this.dataLocalities.forEach((localities: any) => {
      theLocality = localities.find(
        (locality: any) => locality.id === parseInt(event.value),
      );
      if (theLocality != undefined) {
        this.registerForm
          .get('municipality_id')
          .setValue(theLocality.municipality.id);
        this.registerForm.get('state_id').setValue(theLocality.state.id);
        this.registerForm
          .get('municipality')
          .setValue(theLocality.municipality.name);
        this.registerForm.get('state').setValue(theLocality.state.name);
      }
    });
  }

  register() {
    if (this.registerForm.invalid) {
      this.registerForm.markAllAsTouched();
      return;
    }

    if (!this.registerForm.value.terms_conditions) {
      this.coreService.emitSubjet.next({
        type: 'Snackbar',
        payload: {
          text: 'Debes aceptar los Términos y Condiciones.',
        },
      });
      return;
    }

    if (!this.registerForm.value.privacy_notice) {
      this.coreService.emitSubjet.next({
        type: 'Snackbar',
        payload: {
          text: 'Debes confirmar que has leído el Aviso de Privacidad.',
        },
      });
      return;
    }

    this.loaderService.show();
    let dataForm = { ...this.registerForm.value };
    dataForm.device_id = 'device_web';
    dataForm.birthdate = this.formatDate(dataForm.birthdate);
    dataForm.phone = '52' + dataForm.phone + '';
    if (dataForm.gender !== 'O') {
      dataForm.gender_value = '';
    }
    this.apiUsersServices.registerMobile(dataForm).subscribe({
      next: (value) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: value.message },
        });
        // console.log('Register response:', value);
        if (value.status) {
          this.registerMode = false;
          const isMobile = window.innerWidth <= 768;

          const dialogRef = this.dialog.open(DialogConfirmCode, {
            width: isMobile ? '90vw' : '350px',
            maxWidth: '95vw',
            height: 'auto',
            maxHeight: 'calc(100vh - 30px)',
            backdropClass: 'nina-dialog-backdrop',
            data: {
              phone: dataForm.phone,
              userData: dataForm,
              userDataResponse: value.data,
              isFirstTime: true,
            },
          });

          dialogRef.afterClosed().subscribe((result) => {
            this.dialogRef.close();
          });
        }
        this.loaderService.hide();
      },
      error: (err) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: 'Hubo un error al procesar tu solicitud' },
        });
        console.error(err);
        this.loaderService.hide();
      },
    });
  }

  private formatDate(date: Date): string {
    return moment(date).format('YYYY-MM-DD');
  }
}

@Component({
  selector: 'dialog-sale-resume',
  templateUrl: 'dialog-sale-resume.html',
  styleUrls: ['dialog-sale-resume.scss'],
})
export class DialogSaleResume {
  saleData: any;

  constructor(
    public dialogRef: MatDialogRef<DialogSaleResume>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public cookies: CookieService,
    private coreService: CoreService,
  ) {
    if (ResumeStorage.exists()) {
      this.saleData = ResumeStorage.getResume();
    } else {
      this.coreService.emitSubjet.next({
        type: 'Snackbar',
        payload: { text: 'No hay datos de venta' },
      });
      this.dialogRef.close();
    }
  }

  ngOnInit(): void { }

  okBtn() {
    this.dialogRef.close();
  }

  goToFacturar() {
    window.open(
      `${environment.urlFacturacion}${this.saleData.idVenta}`,
      '_blank',
    );
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

declare var google: any;

@Component({
  selector: 'dialog-shipping-type',
  templateUrl: 'dialog-shipping-type.html',
  styleUrls: ['dialog-shipping-type.scss'],
})
export class DialogShippingType {
  productInCart: any = {};
  shippeable: boolean = false;
  sucursal: any = {
    idSucursal: -1,
    urlFoto: '',
    nombre: '',
    telefono: '',
    celularSucursal: '',
    direccion: '',
    latitud: '',
    longitud: '',
    horario: '',
    selected: false,
    existencia: 0,
  };
  sucursalesWithTheProduct: any = [];
  allSucursales: any = [];
  cantidad: number = 0;
  fusionBranches: any[] = [];
  sucursalesCercanas: any[] = [];
  first: boolean = true;

  lat: number = 25.537911020290082;
  lng: number = -103.41543316841125;
  zoom = 13;
  sucursalSelected: any = {};
  myLatitude: number = 0;
  myLongitude: number = 0;
  direccion: string = '';
  objMyDirection: any = {};
  idProductoAgrupador: number = -1;
  savedAddress: any = null;
  tokenSSLoged: any = null;
  userData: any = null;
  promotion: any = null;
  hasAddress: boolean = false;
  savedAddressDisplay: string = '';
  @ViewChild('searchInput', { static: false }) searchInput!: ElementRef;

  constructor(
    private ngZone: NgZone,
    private cd: ChangeDetectorRef,
    private mapsAPILoader: MapsAPILoader,
    private loaderService: LoaderService,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<DialogShippingType>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public cookieService: CookieService,
    public apiServices: ApiService,
    public cookies: CookieService,
    public geolocationService: GeolocationService,
    public geocodingService: GeoCodingService,
    private gtm: GoogleTagManagerService,
    public dialog: MatDialog,
    private usersService: UsersService,
  ) {
    if (data.promotion == null) {
      this.productInCart = data.product;
      this.cantidad = data.qty;
      this.idProductoAgrupador = data.idProductoAgrupador;
    } else {
      this.promotion = data.promotion;
      this.userData = data.user;
    }
    this.tokenSSLoged = this.cookies.check('UL');
  }

  ngOnInit(): void {
    this.getBranches();
    if (this.promotion == null) {
      this.getBranchesByProductId();
    } else {
      this.getPromotionBranches();
    }
  }

  findLocation() {
    if (this.shippeable) {
      if (this.sucursal.idSucursal > 0) {
        this.sucursal.selected = false;
      }
      this.sucursal = {
        idSucursal: -1,
        urlFoto: '',
        nombre: '',
        telefono: '',
        celularSucursal: '',
        direccion: '',
        latitud: '',
        longitud: '',
        horario: '',
        selected: false,
        existencia: 0,
      };
      this.mapsAPILoader.load().then(() => {
        if (!this.searchInput?.nativeElement) {
          return;
        }

        const autocomplete = new google.maps.places.Autocomplete(
          this.searchInput.nativeElement,
          {
            types: ['geocode'],
            componentRestrictions: { country: 'mx' },
          },
        );

        autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
            const place = autocomplete.getPlace();

            if (place.geometry) {
              this.lat = place.geometry.location.lat();
              this.lng = place.geometry.location.lng();

              this.myLatitude = this.lat;
              this.myLongitude = this.lng;

              this.geocodingService
                .getLocation(this.myLatitude, this.myLongitude)
                .subscribe({
                  next: (value) => {
                    // console.log("Ubicacion", value)
                    if (value != null) {
                      if (value.results.length > 0) {
                        this.direccion = value.results[0].formatted_address;
                        this.objMyDirection = value.results[0];
                      }
                    }
                    this.fusionBranches = [];
                    this.sucursalesWithTheProduct.forEach((sucursal: any) => {
                      let tempObj = this.allSucursales.find(
                        (element: any) =>
                          sucursal.idSucursal === element.idSucursal,
                      );
                      this.fusionBranches.push({ ...sucursal, ...tempObj });
                    });
                    let sucursalesFiltrar: any = [];
                    for (
                      let index = 0;
                      index < this.fusionBranches.length;
                      index++
                    ) {
                      this.fusionBranches[index].distancia ??=
                        +this.calcularDistancia(
                          this.myLatitude,
                          this.myLongitude,
                          +this.fusionBranches[index].latitud,
                          +this.fusionBranches[index].longitud,
                        );
                      if (
                        this.fusionBranches[index].distancia <=
                        this.fusionBranches[index].distanciaMaximaKms
                      ) {
                        sucursalesFiltrar.push(this.fusionBranches[index]);
                      }
                    }
                    this.sucursalesCercanas = [];
                    this.sucursalesCercanas = [...sucursalesFiltrar];
                    if (this.sucursalesCercanas.length > 0) {
                      this.sucursalesCercanas.sort(
                        (a, b) => a.distancia - b.distancia,
                      );
                      this.sucursal = this.sucursalesCercanas[0];
                      this.sucursal.selected = true;
                    }
                    this.cd.detectChanges();
                  },
                  error: (err) => {
                    // console.log(err)
                  },
                });
            }
          });
        });
      });
    }
  }

  private normalizeAddressText(value: any): string {
    return String(value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[.,#]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private getAddressComponent(result: any, type: string): string {
    const component = result?.address_components?.find(
      (item: any) => item.types?.includes(type)
    );

    return component?.long_name ?? '';
  }


  private openComplementAddressDialog(matchingAddress: any): void {
    const dialogRef = this.dialog.open(DialogNewAddressComponent, {
      width: '600px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      backdropClass: 'nina-dialog-backdrop',
      autoFocus: false,
      data: {
        address: matchingAddress,
        referenceLocation: this.objMyDirection,
        complementAddress: true
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result?.created || !result?.address) {
        return;
      }

      this.savedAddress = result.address;
      this.hasAddress = true;
      this.savedAddressDisplay = this.getSavedAddressDisplay(
        this.savedAddress
      );

      localStorage.setItem(
        'MyAddressSelected',
        JSON.stringify(this.savedAddress)
      );

      this.objMyDirection.user_address = this.savedAddress;

      this.cookies.set(
        'MyAddress',
        JSON.stringify(this.objMyDirection),
        {
          expires: 1,
          sameSite: 'Strict'
        }
      );

      this.continueWithAddress();
    });
  }


  private getDistanceInMeters(
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number
  ): number {
    const earthRadius = 6371000;
    const toRadians = (value: number) => value * Math.PI / 180;
    const dLat = toRadians(lat2 - lat1);
    const dLng = toRadians(lng2 - lng1);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLng / 2) ** 2;

    return 2 * earthRadius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  private findMatchingSavedAddress(
    addresses: any[],
    latitude: number,
    longitude: number,
    mapAddress: any
  ): any | null {
    const coordinateToleranceMeters = 30;

    const coordinateMatch = addresses.find((address: any) => {
      const lat = Number(address.lat);
      const lng = Number(address.lng);

      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return false;
      }

      return this.getDistanceInMeters(latitude, longitude, lat, lng)
        <= coordinateToleranceMeters;
    });

    if (coordinateMatch) {
      return coordinateMatch;
    }

    const mapStreet = this.normalizeAddressText(
      this.getAddressComponent(mapAddress, 'route')
    );

    const mapExtNumber = this.normalizeAddressText(
      this.getAddressComponent(mapAddress, 'street_number')
    );

    if (!mapStreet || !mapExtNumber) {
      return null;
    }

    return addresses.find((address: any) =>
      this.normalizeAddressText(address.street) === mapStreet &&
      this.normalizeAddressText(address.ext_number) === mapExtNumber
    ) ?? null;
  }

  private getSavedAddressDisplay(address: any): string {
    if (!address) return '';

    if (typeof address === 'string') return address;

    const locality =
      typeof address.locality === 'object'
        ? address.locality?.name
        : address.locality;

    const parts = [
      address.street ?? address.calle,
      address.ext_number ?? address.numeroExterior,
      locality ?? address.locality_name ?? address.colonia,
      address.municipality?.name ?? address.municipality ?? address.municipio,
      address.state?.name ?? address.state ?? address.estado,
      address.zip_code ?? address.codigoPostal,
      address.references ?? address.referencias
    ];

    return [...new Set(
      parts
        .filter((value: any) => value !== null && value !== undefined)
        .map((value: any) => String(value).trim())
        .filter((value: string) => value.length > 0)
    )].join(', ');
  }

  getUbication() {
    this.geolocationService
      .getLocation()
      .then((position) => {
        this.myLatitude = position.coords.latitude;
        this.myLongitude = position.coords.longitude;
        this.lat = this.myLatitude;
        this.lng = this.myLongitude;
        this.geocodingService
          .getLocation(this.myLatitude, this.myLongitude)
          .subscribe({
            next: (value) => {
              if (value != null) {
                if (value.results.length > 0) {
                  this.direccion = value.results[0].formatted_address;
                  this.objMyDirection = value.results[0];
                }
              }

              this.fusionBranches = [];
              this.sucursalesWithTheProduct.forEach((sucursal: any) => {
                let tempObj = this.allSucursales.find(
                  (element: any) => sucursal.idSucursal === element.idSucursal,
                );
                this.fusionBranches.push({ ...sucursal, ...tempObj });
              });
              let sucursalesFiltrar: any = [];
              for (let index = 0; index < this.fusionBranches.length; index++) {
                this.fusionBranches[index].distancia ??=
                  +this.calcularDistancia(
                    this.myLatitude,
                    this.myLongitude,
                    +this.fusionBranches[index].latitud,
                    +this.fusionBranches[index].longitud,
                  );
                if (
                  this.fusionBranches[index].distancia <=
                  this.fusionBranches[index].distanciaMaximaKms
                ) {
                  sucursalesFiltrar.push(this.fusionBranches[index]);
                }
              }
              this.sucursalesCercanas = [];
              this.sucursalesCercanas = [...sucursalesFiltrar];
              if (this.sucursalesCercanas.length > 0) {
                this.sucursalesCercanas.sort(
                  (a, b) => a.distancia - b.distancia,
                );
                if (this.sucursal.idSucursal > 0) {
                  this.sucursal.selected = false;
                }
                this.sucursal = this.sucursalesCercanas[0];
                this.sucursal.selected = true;
                this.sucursalesWithTheProduct[
                  this.sucursalesWithTheProduct.findIndex(
                    (suc: any) => suc.idSucursal === this.sucursal.idSucursal,
                  )
                ].selected = true;
              }
              this.cd.detectChanges();
            },
            error: (err) => {
              // console.log(err)
            },
          });
      })
      .catch((error) => {
        this.first = false;
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: 'No se ha permitido acceder a tu ubicación, esto nos ayudaria a brindarte un mejor servicio',
          },
        });
      });
  }

  changeSelectedShipping(type: string) {
    if (type === 'Pick') {
      this.gtm.pushTag({ event: 'pick_and_go_selected' });
      this.first = true;
      this.shippeable = false;
      // if(this.sucursal.idSucursal > 0){
      //   this.sucursal = {idSucursal:-1 ,urlFoto:"", nombre: "", telefono:"", celularSucursal:"", direccion:"", latitud:"", longitud:"", horario:"", selected:false, existencia:0}
      // }
      this.sucursalesWithTheProduct.forEach((sucursal: any) => {
        sucursal.selected = false;
      });
      this.cd.detectChanges();
      if (this.sucursalesWithTheProduct.length > 0) {
        this.sucursal = this.fusionBranches[0];
        this.sucursal.selected = true;
        this.sucursalesWithTheProduct[
          this.sucursalesWithTheProduct.findIndex(
            (suc: any) => suc.idSucursal === this.sucursal.idSucursal,
          )
        ].selected = true;
        this.cd.detectChanges();
        // this.getUbication()
      }
    } else if (type === 'Send') {
      this.gtm.pushTag({ event: 'delivery_selected' });

      this.shippeable = true;

      this.sucursalesWithTheProduct.forEach((sucursal: any) => {
        sucursal.selected = false;
      });

      this.sucursal = {
        idSucursal: -1,
        urlFoto: '',
        nombre: '',
        telefono: '',
        celularSucursal: '',
        direccion: '',
        latitud: '',
        longitud: '',
        horario: '',
        selected: false,
        existencia: 0,
      };

      this.cd.detectChanges();

      setTimeout(() => {
        this.findLocation();
      });

      this.getUbication();
    }
  }

  getBranches() {
    let data = { token: this.cookies.get('Token') };
    this.apiServices.getSucursales(data).subscribe({
      next: (value) => {
        // console.log("All branches", value)
        this.allSucursales = value;
      },
      error: (err) => {
        // console.log(err)
      },
    });
  }

  getBranchesByProductId() {
    this.loaderService.show();
    let data = {
      token: this.cookies.get('Token'),
      idProducto: this.productInCart.idProducto,
      qty: this.cantidad,
    };
    this.apiServices
      .getSucursalesPorProductoSegunCantidadSolicitada(data)
      .subscribe({
        next: (value) => {
          // console.log("By Product", value)
          this.sucursalesWithTheProduct = value;
          this.sucursalesWithTheProduct.forEach((element: any) => {
            element.selected = false;
          });

          if (this.sucursalesWithTheProduct.length > 0) {
            this.fusionBranches = [];
            this.sucursalesWithTheProduct.forEach((sucursal: any) => {
              let tempObj = this.allSucursales.find(
                (element: any) => sucursal.idSucursal === element.idSucursal,
              );
              this.fusionBranches.push({ ...sucursal, ...tempObj });
            });
            this.sucursal = this.fusionBranches[0];
            this.sucursal.selected = true;
            this.sucursalesWithTheProduct[
              this.sucursalesWithTheProduct.findIndex(
                (suc: any) => suc.idSucursal === this.sucursal.idSucursal,
              )
            ].selected = true;
            this.cd.detectChanges();
            // this.getUbication()
          }
          this.loaderService.hide();
        },
        error: (err) => {
          // console.log(err)
          this.loaderService.hide();
        },
      });
  }

  getPromotionBranches() {
    this.loaderService.show();
    let data = {
      token: this.cookies.get('Token'),
      idPromo: this.promotion.idPromo,
      idCliente: this.userData.id,
    };
    this.apiServices.getSucursalesQuePuedenOfrecerUnaPromocion(data).subscribe({
      next: (value) => {
        // console.log(value)
        if (value.length == 0) {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text: 'Lo sentimos, la promoción seleccionada no esta disponible hoy',
            },
          });
          this.dialogRef.close();
        } else {
          this.sucursalesWithTheProduct = value;
          this.sucursalesWithTheProduct.forEach((element: any) => {
            element.sucursal = element.nombre;
            element.selected = false;
          });
          this.sucursal = this.sucursalesWithTheProduct[0];
          this.sucursal.selected = true;
          this.sucursalesWithTheProduct[
            this.sucursalesWithTheProduct.findIndex(
              (suc: any) => suc.idSucursal === this.sucursal.idSucursal,
            )
          ].selected = true;
        }
        this.cd.detectChanges();
        this.loaderService.hide();
      },
      error: (err) => {
        // console.log(err)
        this.loaderService.hide();
      },
    });
  }

  changeSelectedChip(event: any, branch: any) {
    if (this.sucursal.idSucursal == branch.idSucursal) {
      if (!this.first) {
        this.sucursal = {
          idSucursal: -1,
          urlFoto: '',
          nombre: '',
          telefono: '',
          celularSucursal: '',
          direccion: '',
          latitud: '',
          longitud: '',
          horario: '',
          selected: false,
          existencia: 0,
        };
      } else {
        this.first = false;
      }
    } else {
      this.sucursal = this.allSucursales.find(
        (element: any) => element.idSucursal === branch.idSucursal,
      );
      this.sucursal.selected = true;
      this.sucursal.existencia = branch.existencia;
    }
  }

  continue(): void {
    if (this.shippeable && !this.hasAddress) {

      const latitude = Number(
        this.myLatitude || this.objMyDirection?.geometry?.location?.lat
      );

      const longitude = Number(
        this.myLongitude || this.objMyDirection?.geometry?.location?.lng
      );

      if (
        !Number.isFinite(latitude) ||
        !Number.isFinite(longitude) ||
        (latitude === 0 && longitude === 0)
      ) {
        this.openDialogAddresses(this.objMyDirection);
        return;
      }

      this.usersService.getAddress().subscribe({
        next: (response) => {
          if (!response?.status) {
            this.openDialogAddresses(this.objMyDirection);
            return;
          }

          const addresses = response.data ?? [];

          const matchingAddress = this.findMatchingSavedAddress(
            addresses,
            latitude,
            longitude,
            this.objMyDirection
          );

          if (matchingAddress) {
            this.openComplementAddressDialog(matchingAddress);
            return;
          }

          this.openDialogAddresses(this.objMyDirection);
        },
        error: (error) => {
          console.error('Error consultando direcciones guardadas:', error);
          this.openDialogAddresses(this.objMyDirection);
        }
      });

      return;
    }

    this.continueWithAddress();
  }

  private continueWithAddress(): void {
    if (this.promotion == null) {
      this.cookies.set('Branch', JSON.stringify(this.sucursal), {
        expires: 1,
        sameSite: 'Strict',
      });
      if (this.cantidad > this.sucursal.existencia) {
        this.cantidad = this.sucursal.existencia;
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: 'Se ajusto la cantidad del producto seleccionado ya que no se cuenta con el inventario necesario',
          },
        });
      }
      this.objMyDirection.user_address = this.savedAddress;
      const tomorrow = new Date();
      tomorrow.setHours(0, 0, 0, 0);
      tomorrow.setDate(tomorrow.getDate() + 1);
      let cart: any = [];
      cart.push({
        idProducto: this.productInCart.idProducto,
        idProductoAgrupador: this.idProductoAgrupador,
        qty: this.cantidad,
      });
      CartStorage.saveCart(cart);
      this.cookies.set('MyAddress', JSON.stringify(this.objMyDirection), {
        expires: 1,
        sameSite: 'Strict',
      });
    } else {
      this.cookies.set('BranchTemp', JSON.stringify(this.sucursal), {
        expires: 1,
        sameSite: 'Strict',
      });
      this.cookies.set('MyAddress', JSON.stringify(this.objMyDirection), {
        expires: 1,
        sameSite: 'Strict',
      });
    }
    this.cookies.set('Shippeable', this.shippeable ? 'true' : 'false', {
      expires: 1,
      sameSite: 'Strict',
    });
    setTimeout(() => {
      this.dialogRef.close();
      if (this.promotion != null) {
        const promotionData = JSON.parse(this.cookies.get('DataPromo'));
        this.coreService.emitSubjet.next({
          type: 'PromoBanner',
          payload: promotionData,
        });
      }
    }, 1500);
  }


  onMapClickEvent(event: any): void {
    this.myLatitude = event.coords.lat;
    this.myLongitude = event.coords.lng;
    this.lat = this.myLatitude;
    this.lng = this.myLongitude;
    this.getUbication();
    this.updateNearbyBranches();
  }

  markerDragEnd(event: any): void {
    this.myLatitude = event.coords.lat;
    this.myLongitude = event.coords.lng;
    this.lat = this.myLatitude;
    this.lng = this.myLongitude;
    this.getUbication();
    this.updateNearbyBranches();
  }

  private updateNearbyBranches(): void {
    if (this.sucursal.idSucursal > 0) {
      this.sucursal.selected = false;
    }

    this.sucursal = {
      idSucursal: -1,
      urlFoto: '',
      nombre: '',
      telefono: '',
      celularSucursal: '',
      direccion: '',
      latitud: '',
      longitud: '',
      horario: '',
      selected: false,
      existencia: 0
    };

    this.fusionBranches = [];

    this.sucursalesWithTheProduct.forEach((sucursal: any) => {
      const tempObj = this.allSucursales.find(
        (element: any) => sucursal.idSucursal === element.idSucursal
      );

      this.fusionBranches.push({
        ...sucursal,
        ...tempObj
      });
    });

    const sucursalesFiltrar: any[] = [];

    for (let index = 0; index < this.fusionBranches.length; index++) {
      this.fusionBranches[index].distancia ??=
        +this.calcularDistancia(
          this.myLatitude,
          this.myLongitude,
          +this.fusionBranches[index].latitud,
          +this.fusionBranches[index].longitud
        );

      if (
        this.fusionBranches[index].distancia <=
        this.fusionBranches[index].distanciaMaximaKms
      ) {
        sucursalesFiltrar.push(this.fusionBranches[index]);
      }
    }

    this.sucursalesCercanas = [...sucursalesFiltrar];

    if (this.sucursalesCercanas.length > 0) {
      this.sucursalesCercanas.sort(
        (a, b) => a.distancia - b.distancia
      );

      this.sucursal = this.sucursalesCercanas[0];
      this.sucursal.selected = true;

      const index = this.sucursalesWithTheProduct.findIndex(
        (suc: any) => suc.idSucursal === this.sucursal.idSucursal
      );

      if (index >= 0) {
        this.sucursalesWithTheProduct[index].selected = true;
      }
    }

    this.cd.detectChanges();
  }

  calcularDistancia(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
  ): number {
    const radioTierra = 6371; // Radio de la Tierra en kilómetros
    const dLat = this.gradoARadianes(lat2 - lat1);
    const dLon = this.gradoARadianes(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.gradoARadianes(lat1)) *
      Math.cos(this.gradoARadianes(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distancia = radioTierra * c;

    return +distancia.toFixed(2);
  }

  gradoARadianes(grados: number): number {
    return grados * (Math.PI / 180);
  }

  openDialogAddresses(obtainedAddress?: any) {
    let data = {};
    if (obtainedAddress != null && obtainedAddress != undefined) {
      data = obtainedAddress;
    }
    const dialogRef = this.dialog.open(DialogAddressComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      backdropClass: 'nina-dialog-backdrop',
      data: { referenceLocation: data },
      autoFocus: false,
    });

    // dialogRef.afterClosed().subscribe((result) => {
    //   this.savedAddress = result?.address ?? null;
    //   // console.log("Direccion seleccionada", this.savedAddress)
    //   if (this.savedAddress != null) {
    //     localStorage.setItem('MyAddressSelected', JSON.stringify(this.savedAddress));
    //     this.hasAddress = true;
    //     this.myLatitude = this.savedAddress.lat;
    //     this.myLongitude = this.savedAddress.lng;
    //     if (this.sucursal.idSucursal > 0) {
    //       this.sucursal.selected = false;
    //     }
    //     this.sucursal = {
    //       idSucursal: -1,
    //       urlFoto: '',
    //       nombre: '',
    //       telefono: '',
    //       celularSucursal: '',
    //       direccion: '',
    //       latitud: '',
    //       longitud: '',
    //       horario: '',
    //       selected: false,
    //       existencia: 0,
    //     };
    //     this.geocodingService
    //       .getLocation(this.myLatitude, this.myLongitude)
    //       .subscribe({
    //         next: (value) => {
    //           if (value != null) {
    //             if (value.results.length > 0) {
    //               this.direccion = value.results[0].formatted_address;
    //               this.objMyDirection = value.results[0];
    //             }
    //           }
    //           this.fusionBranches = [];
    //           this.sucursalesWithTheProduct.forEach((sucursal: any) => {
    //             let tempObj = this.allSucursales.find(
    //               (element: any) => sucursal.idSucursal === element.idSucursal,
    //             );
    //             this.fusionBranches.push({ ...sucursal, ...tempObj });
    //           });
    //           let sucursalesFiltrar: any = [];
    //           for (let index = 0; index < this.fusionBranches.length; index++) {
    //             this.fusionBranches[index].distancia ??=
    //               +this.calcularDistancia(
    //                 this.myLatitude,
    //                 this.myLongitude,
    //                 +this.fusionBranches[index].latitud,
    //                 +this.fusionBranches[index].longitud,
    //               );
    //             if (
    //               this.fusionBranches[index].distancia <=
    //               this.fusionBranches[index].distanciaMaximaKms
    //             ) {
    //               sucursalesFiltrar.push(this.fusionBranches[index]);
    //             }
    //           }
    //           this.sucursalesCercanas = [];
    //           this.sucursalesCercanas = [...sucursalesFiltrar];
    //           if (this.sucursalesCercanas.length > 0) {
    //             this.sucursalesCercanas.sort(
    //               (a, b) => a.distancia - b.distancia,
    //             );
    //             this.sucursal = this.sucursalesCercanas[0];
    //             this.sucursal.selected = true;
    //             this.sucursalesWithTheProduct[
    //               this.sucursalesWithTheProduct.findIndex(
    //                 (suc: any) => suc.idSucursal === this.sucursal.idSucursal,
    //               )
    //             ].selected = true;
    //           }
    //           // console.log("Direccion seleccionada", this.objMyDirection)
    //           this.cd.detectChanges();
    //         },
    //         error: (err) => {
    //           // console.log(err)
    //         },
    //       });
    //   } else {
    //     this.hasAddress = false;
    //     this.coreService.emitSubjet.next({
    //       type: 'Snackbar',
    //       payload: { text: 'No se selecciono ninguna dirección' },
    //     });
    //   }
    // });

    dialogRef.afterClosed().subscribe((result) => {
      this.savedAddress = result?.address ?? null;

      if (!this.savedAddress) {
        this.hasAddress = false;
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: 'No se seleccionó ninguna dirección' }
        });
        return;
      }

      localStorage.setItem('MyAddressSelected', JSON.stringify(this.savedAddress));

      this.hasAddress = true;
      this.savedAddressDisplay = this.getSavedAddressDisplay(this.savedAddress);

      this.myLatitude = Number(this.savedAddress.lat);
      this.myLongitude = Number(this.savedAddress.lng);
      this.lat = this.myLatitude;
      this.lng = this.myLongitude;

      this.cd.detectChanges();

      this.geocodingService
        .getLocation(this.myLatitude, this.myLongitude)
        .subscribe({
          next: (value) => {
            if (value?.results?.length > 0) {
              this.direccion = value.results[0].formatted_address;
              this.objMyDirection = value.results[0];
            }

            this.cd.detectChanges();
          },
          error: (err) => {
            console.error('Error al obtener la dirección:', err);
          }
        });
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-confirm-code',
  templateUrl: 'dialog-confirm-code.html',
  styleUrls: ['dialog-confirm-code.scss'],
})

export class DialogConfirmCode {
  codeConfirmForm: any;
  phone = '';
  dataUserRegister: any = null;
  dataUserRegisterResponse: any = null;
  dataLocalities: Observable<any[]> = of([]);
  theLocality: any = { id: -1, name: '' };
  firstTime: boolean = false;

  savedCode: string = '';

  minutePassed: boolean = false;
  countdownSeconds: number = 120;
  codeFromLogin: string = '';

  private countdownInterval: any;

  codeAlreadyShown: boolean = false;
  verificated: boolean = false;
  attempts = 0;

  constructor(
    private loaderService: LoaderService,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<DialogConfirmCode>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public cookieService: CookieService,
    public formBuilder: FormBuilder,
    public apiUSersService: UsersService,
    private gtm: GoogleTagManagerService,
    public apiServices: ApiService,
  ) {
    this.attempts = data.attempts;
    this.phone = data.phone;
    this.dataUserRegister = data.userData ?? null;
    this.dataUserRegisterResponse = data.userDataResponse ?? null;
    this.firstTime = data.isFirstTime ?? false;
    this.codeFromLogin = data.code ?? '';
    // console.log("DataUserRegisterResponse", this.dataUserRegisterResponse);
    if (this.dataUserRegisterResponse) {
      this.savedCode = this.firstTime
        ? (this.dataUserRegisterResponse.code ?? '')
        : (this.dataUserRegisterResponse.confirmation_code ?? '');
    }
    else if (this.codeFromLogin) {
      this.savedCode = this.codeFromLogin;
    }
    else {
      // console.log('No se pudo recuperar el codigo de confirmacion');
    }

    this.createForms();
  }

  ngOnInit(): void {
    if (this.firstTime) {
      this.searchDataZipCode();
    }

    // Inicia los 2 minutos al abrir el dialog
    this.startCountdown();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  createForms() {
    this.codeConfirmForm = this.formBuilder.group({
      code: ['', [Validators.required]],
    });
  }

  get code() {
    return this.codeConfirmForm.get('code');
  }

  resendCode() {
    this.attempts++;
    this.verificated = true;
    if (!this.minutePassed) {
      return;
    }

    let dataResend: any = {};
    dataResend.device_id = 'device_web';
    dataResend.phone = this.phone + '';
    dataResend.attempts = this.attempts;

    this.loaderService.show();
    this.apiUSersService.resendConfirmationCode(dataResend).subscribe({
      next: (value) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: value.message,
          },
        });
        if (value.status) {
          this.startCountdown();
        }
        this.loaderService.hide();
      },
      error: (err) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: 'Hubo un error al procesar tu solicitud',
          },
        });
        console.error(err);
        this.loaderService.hide();
      },
    });
  }

  startCountdown() {
    if (environment.development) {
      this.showSavedCode();
    }
    this.minutePassed = false;
    this.countdownSeconds = 120;

    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    this.countdownInterval = setInterval(() => {
      this.countdownSeconds--;

      if (this.countdownSeconds <= 0) {
        this.countdownSeconds = 0;
        this.minutePassed = true;

        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    }, 1000);
  }

  private showSavedCode() {
    if (this.codeAlreadyShown) {
      return;
    }

    this.codeAlreadyShown = true;

    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }

    this.codeConfirmForm.patchValue({
      code: this.savedCode,
    });

    // this.codeConfirmForm.get('code').disable({
    //   emitEvent: false,
    // });

    // this.coreService.emitSubjet.next({
    //   type: 'Snackbar',
    //   payload: {
    //     text: 'Tu código de confirmación es: ' + this.savedCode,
    //   },
    // });
  }

  ngOnDestroy() {
    localStorage.setItem('attempts', this.attempts + '');
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  confirm() {
    this.loaderService.show();
    let dataForm = this.codeConfirmForm.getRawValue();
    dataForm.device_id = 'device_web';
    dataForm.phone = this.phone + '';
    dataForm.code = dataForm.code + '';

    if (dataForm.phone.length > 0) {
      this.apiUSersService.confirmCode(dataForm).subscribe({
        next: (value) => {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text: value.message,
            },
          });

          if (value.status) {
            // console.log(value)
            this.cookieService.set('uid', value.data.user.id, {
              expires: 1,
              sameSite: 'Strict',
            });
            this.cookieService.set('UL', value.data.token, {
              expires: 1,
              sameSite: 'Strict',
            });
            this.cookieService.set('ss', value.data.ssToken, {
              expires: 1,
              sameSite: 'Strict',
            });
            if (this.firstTime === true) {
              const now = new Date();
              const formatted =
                now.getFullYear() +
                '-' +
                String(now.getMonth() + 1).padStart(2, '0') +
                '-' +
                String(now.getDate()).padStart(2, '0') +
                'T' +
                String(now.getHours()).padStart(2, '0') +
                ':' +
                String(now.getMinutes()).padStart(2, '0');
              let bodyReq: any = {};
              bodyReq.idCliente = this.dataUserRegisterResponse.id;
              bodyReq.nombres = this.dataUserRegister.nombres;
              bodyReq.paterno = this.dataUserRegister.last_name;
              bodyReq.materno = this.dataUserRegister.last_name2;
              bodyReq.celular = this.dataUserRegister.phone;
              bodyReq.correo = '';
              bodyReq.fechaNacimiento = this.dataUserRegister.birthdate;
              bodyReq.sexo =
                this.dataUserRegister.gender === 'M'
                  ? 'Masculino'
                  : this.dataUserRegister.gender === 'F'
                    ? 'Femenino'
                    : this.dataUserRegister.gender === 'O'
                      ? this.dataUserRegister.gender_value
                      : 'Otro';
              bodyReq.codigoPostal = this.dataUserRegister.main_zip_code;
              bodyReq.colonia = this.theLocality.name;
              bodyReq.fechaRegistroApp = formatted;
              bodyReq.validar = this.verificated;
              this.apiServices.insertaModificaClienteV2(bodyReq).subscribe({
                next: (value) => {
                  this.dialogRef.close();
                  this.gtm.pushTag({
                    event: 'signup_complete',
                  });
                },
                error: (err) => {
                  this.loaderService.hide();
                  this.dialogRef.close();
                },
              });
            } else {
              this.dialogRef.close();
              this.gtm.pushTag({
                event: 'signup_complete',
              });
            }
          }
          this.loaderService.hide();
        },
        error: (err) => {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text: 'Hubo un error al procesar tu solicitud',
            },
          });
          console.error(err);
          this.loaderService.hide();
        },
      });
    }
  }

  searchDataZipCode() {
    let theZipCode = this.dataUserRegister.main_zip_code;

    this.apiUSersService.getLocalitiesByZipCode(theZipCode).subscribe({
      next: (value) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: value.message,
          },
        });

        if (value.status) {
          this.dataLocalities = of(value.data);

          this.dataLocalities.forEach((localities: any) => {
            this.theLocality = localities.find(
              (locality: any) =>
                locality.id === this.dataUserRegister.locality_id,
            );
          });
        }
      },

      error: (err) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: 'Hubo un error al procesar tu solicitud',
          },
        });
      },
    });
  }

  formatCountdown(): string {
    const minutes = Math.floor(this.countdownSeconds / 60);
    const seconds = this.countdownSeconds % 60;

    return `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }
}

@Component({
  selector: 'dialog-show-coupons',
  templateUrl: 'dialog-show-coupons.html',
  styleUrls: ['dialog-show-coupons.scss'],
})
export class DialogShowCoupons {
  constructor(
    private loaderService: LoaderService,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<DialogShowCoupons>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public apiServices: ApiService,
    public cookies: CookieService,
  ) { }

  ngOnInit(): void { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-saved-addresses',
  templateUrl: 'dialog-saved-addresses.html',
  styleUrls: ['dialog-saved-addresses.scss'],
})
export class DialogSavedAddresses {
  dataAddresses: any[] = [];
  constructor(
    private loaderService: LoaderService,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<DialogSavedAddresses>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public apiUsersServices: UsersService,
  ) { }

  ngOnInit(): void {
    this.getDataAddresses();
  }

  getDataAddresses() {
    this.loaderService.show();
    this.apiUsersServices.getAddress().subscribe({
      next: (value) => {
        if (value.status) {
          this.dataAddresses = value.data;
        } else {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: 'Hubo un error al procesar tu solicitud' },
          });
        }
        this.loaderService.hide();
      },
      error: (err) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: 'Hubo un error al procesar tu solicitud' },
        });
        console.error(err);
        this.loaderService.hide();
      },
    });
  }

  onSelectAddress(address: any) {
    this.dialogRef.close({ address: address });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
